import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';

import { ModalInfo, ModalSubmitWithClosingBtnType } from '../../../../shared/models';
import { ModalComponent } from '../../modal/modal.component';

export interface ConfirmModalData {
  titleKey: string;
  textKey: string;
  confirmType?: ModalSubmitWithClosingBtnType;
  cancelBtnId?: string;
  confirmBtnId?: string;
  extraCssClass?: string;
}

@Component({
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.scss'],
  imports: [CommonModule, TranslateModule, ModalComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmModalComponent {
  private readonly dialogRef = inject<MatDialogRef<ConfirmModalComponent, boolean>>(MatDialogRef);
  protected readonly data: ConfirmModalData = inject(MAT_DIALOG_DATA);

  private readonly infoSrc$ = new BehaviorSubject<ModalInfo>({
    type: 'success-modal',
    extraCssClass: this.data.extraCssClass ?? 'confirm-modal',
    closeModalBtnId: 'close-confirm-modal',
    header: {
      title: this.data.titleKey,
      text: this.data.textKey,
    },
    actions: {
      cancel: {
        id: this.data.cancelBtnId ?? 'cancel-confirm-btn',
      },
      submitWithClothing: {
        id: this.data.confirmBtnId ?? 'confirm-confirm-btn',
        type: this.data.confirmType ?? 'confirm',
        extraClass: 'bright',
      },
    },
  });

  protected readonly info$ = this.infoSrc$.asObservable();

  closeModal(value: unknown = null): void {
    this.dialogRef.close(value === true);
  }
}
